<generic-modal
    [showStream]="showStream"
    [actionStream]="actionStream"
    [okEnabled]="canSave"
    [buttonsVisible]="view === 'form'"
    [showReset]="showReset"
>
    <div class="c-user-payment-modal__header">
        <user-avatar
            class="c-user-payment-modal__header-avatar"
            [user]="user"
        ></user-avatar>
        <span class="c-user-payment-modal__header-name">{{user.name}}</span>
    </div>

    <div *ngIf="!ready" class="u-loader u-loader--relative"></div>

    <ng-container *ngIf="ready">

        <!-- LIST VIEW: shown when 2+ periods -->
        <ng-container *ngIf="view === 'list'">
            <div
                class="c-user-employment-modal__period"
                *ngFor="let period of periods"
                (click)="selectPeriod(period)"
            >
                <span class="c-user-employment-modal__period-range">
                    {{formatDate(period.startDate)}} &mdash;
                    {{period.endDate ? formatDate(period.endDate) : i18n.present}}
                </span>
                <span class="c-user-employment-modal__period-edit"></span>
            </div>
            <div
                class="c-user-employment-modal__add-new"
                (click)="startCreate()"
            >
                + {{i18n.addNew}}
            </div>
        </ng-container>

        <!-- FORM VIEW: shown when 0 or 1 period, or editing/creating from list -->
        <ng-container *ngIf="view === 'form'">
            <div
                *ngIf="fromList"
                class="c-user-employment-modal__back"
                (click)="goBack()"
            >
                &larr; {{i18n.back}}
            </div>

            <div class="c-user-employment-modal__field">
                <label class="c-user-employment-modal__label">{{i18n.startDate}}</label>
                <date-picker
                    [selection]="startDateSubject"
                    [preselected]="preselectedStartStream"
                    [position]="'align-left'"
                    [iconClass]="'c-date-picker__input--start'"
                ></date-picker>
            </div>

            <div class="c-user-employment-modal__field">
                <label class="c-user-employment-modal__label">{{i18n.endDate}}</label>
                <label class="c-user-employment-modal__still-employed">
                    <input
                        type="checkbox"
                        [(ngModel)]="stillEmployed"
                        (change)="onStillEmployedChange()"
                    />
                    {{i18n.stillEmployed}}
                </label>
                <date-picker
                    *ngIf="!stillEmployed"
                    [selection]="endDateSubject"
                    [preselected]="preselectedEndStream"
                    [position]="'align-left'"
                    [iconClass]="'c-date-picker__input--end'"
                ></date-picker>
            </div>

            <div
                *ngIf="selectedPeriod !== null"
                class="c-user-employment-modal__add-new"
                (click)="startCreate()"
            >
                + {{i18n.addNew}}
            </div>
        </ng-container>

    </ng-container>
</generic-modal>
